export const headerProps = (props: $Object, { column }: $Object) =>
  getStyles(props, column.align);

export const cellProps = (props: $Object, { cell }: $Object) =>
  getStyles(props, cell.column.align);

const getStyles = (props: $Object, align = 'left') => [
  props,
  {
    style: {
      justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
      alignItems: 'center',
      display: 'flex',
    },
  },
];
